import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { WorkspaceTranscriptDetailsContext } from '@/containers/Transcript/context';
import type { TranscriptPublishType } from '@/enums';
import { TabKey } from '@/screens/Transcript/interfaces';
import type { RootState } from '@/store';
import { useIsInternalUser, useHasDataStewardRole } from '@/store/selectors';
import { Details, Summary, Transcript, Entities } from '../Tab';

const selectCanViewSummaryTab = (state: RootState) => /*state.group.features.projectTabs.summary*/ true;

export const useWorkspaceTranscriptTabs = () => {
  const ctx = useContext(WorkspaceTranscriptDetailsContext);
  const hasDataStewardRole = useHasDataStewardRole();
  const isInternalUser = useIsInternalUser();
  const canViewSummaryTab = useSelector(selectCanViewSummaryTab);

  const access = useMemo(() => {
    return {
      transcription: isInternalUser || canAccessTranscription(ctx?.settings?.publishType),
    };
  }, [
    ctx?.settings?.publishType,
    isInternalUser,
  ]);

  return useMemo(() => {

    if (hasDataStewardRole) {
      return [
        {
          key: TabKey.Transcript,
          title: 'Transcript',
          component: Transcript,
        },
        {
          key: TabKey.Entities,
          title: 'Entities',
          component: Entities,
        },
      ];
    }

    return [
      access.transcription && {
        key: TabKey.Transcript,
        title: 'Transcript',
        component: Transcript,
      },
      /*
      isInternalUser && {
        key: TabKey.Highlights,
        title: 'Highlights',
        component: Highlights,
      },
            */
      // {
      //   key: TabKey.Entities,
      //   title: 'Entities',
      //   component: Entities,
      // },
      (isInternalUser || canViewSummaryTab) && {
        key: TabKey.Summary,
        title: 'Summary',
        component: Summary,
      },
      {
        key: TabKey.Details,
        title: 'Details',
        component: Details,
      },
    ].filter(Boolean);
  }, [
    canViewSummaryTab,
    access.transcription,
    hasDataStewardRole,
    isInternalUser,
  ]);
};

function canAccessTranscription(typeId: TranscriptPublishType) {
  return true;
  //Publishing doesn't really exist as a concept in genai yet, just assume everyone has access
  /*
  return typeId === TranscriptPublishType.RecordingAndTranscript
    || typeId === TranscriptPublishType.TranscriptOnly;
    */
}